export default {
  id: 230,
  title: 'Target #230 - Connection',
  url: 'https://cssbattle.dev/play/230',
  colors: ['#3F4869', '#F4DA64'],
  solution:
    '<p a><p b><p c><p d><style>p[b],p[c]{border-radius:1in}p[c],p[d]{width:80;height:80}p[a],p[d]{background:#f4da64}body{background:#3f4869}p{position:fixed;margin:0}p[a]{top:140;left:100;width:200;height:20}p[b]{top:70;left:120;width:120;height:120;border:20px solid #f4da64;border-left-color:transparent}p[c]{top:90;left:140;border:20px solid #3f4869;border-left-color:transparent}p[d]{top:110;left:160;border-radius:1in',
}
